import { useDateSettings } from "src/contexts/global/ApolloSettingsContext";
import {
  useActiveFilterCount,
  useFteMode,
} from "src/contexts/filterAndFte/FilterAndFteContext";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useOrgFeatureFlagsForTenant } from "src/hooks/orgConfig/hooks/useOrgFeatureFlagsForTenant";

/**
 * Bundles the sidebar's feature-flag and filter/FTE-mode sources into one
 * flat result, so useSideNavItemBuilder doesn't need to call each of these
 * hooks (and derive enableDesigns) itself.
 */
const useSidebarFeatureFlags = () => {
  const {
    enableTagExplorer,
    enableAIChat,
    enableOrgDesign,
    enableDemoODOptions,
    enableTeamCanvas,
    enablePositionBackedVacancies,
    enableSlidesTeamByTeamPagination,
    enableWorkforceGuardrails,
  } = useWorkspaceFeatureFlags();
  const { featureFlags: orgFeatureFlags } = useOrgFeatureFlagsForTenant();
  const enableDesigns = orgFeatureFlags?.designs?.enableDesigns ?? false;
  const dateSettings = useDateSettings();
  const activeFilterCount = useActiveFilterCount();
  const fteMode = useFteMode();

  return {
    enableTagExplorer,
    enableAIChat,
    enableOrgDesign,
    enableDemoODOptions,
    enableTeamCanvas,
    enablePositionBackedVacancies,
    enableSlides: Boolean(enableSlidesTeamByTeamPagination),
    enableWorkforceGuardrails: Boolean(enableWorkforceGuardrails),
    enableDesigns,
    dateSettings,
    activeFilterCount,
    fteMode,
  };
};

export default useSidebarFeatureFlags;
